var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bar-top" }, [
    _c("div", { staticClass: "logo" }, [
      _c("svg", { staticClass: "icon", attrs: { "aria-hidden": "true" } }, [
        _c("use", { attrs: { "xlink:href": "#icon-skeleton" } }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "logo-text" }, [_vm._v("Page Skeleton")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tools" },
      [
        _c(
          "div",
          { staticClass: "routes-dropdown" },
          [
            _c(
              "el-dropdown",
              {
                attrs: { size: "small", type: "primary", "split-button": "" },
                on: { command: _vm.handleDropdownSelect },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s("Routes: " + _vm.currentRoute) +
                    "\n          "
                ),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  _vm._l(_vm.dropDownRoutes, function (route, i) {
                    return _c(
                      "el-dropdown-item",
                      { key: i, attrs: { command: route } },
                      [_vm._v(_vm._s(route.url))]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("el-button", {
          attrs: { type: "success", icon: "el-icon-mobile-phone", circle: "" },
          on: { click: _vm.preview },
        }),
        _vm._v(" "),
        _c("el-button", {
          attrs: { type: "primary", icon: "el-icon-edit", circle: "" },
          on: { click: _vm.write },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "documents" }, [
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href: "https://github.com/ElemeFE/page-skeleton-webpack-plugin",
              target: "_blank",
            },
          },
          [_vm._v("Documents")]
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href: "https://zhuanlan.zhihu.com/p/34702561",
              target: "_blank",
            },
          },
          [_vm._v("Blog")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }